var map = {
	"./example-bg.svg": 7964,
	"./img/douglasFir/abruptTransition.jpg": 1542,
	"./img/douglasFir/fusiformLowMag.jpg": 2327,
	"./img/douglasFir/helicalThickeningsHighMag.jpg": 4411,
	"./img/douglasFir/helicalThickeningsHighMagRadial.jpg": 1646,
	"./img/douglasFir/piceoidPits.jpg": 3840,
	"./img/douglasFir/resinCanal.jpg": 1141,
	"./img/hardPine/abruptTransitionResinCanal.jpg": 1765,
	"./img/hardPine/dentateRayTracheid.jpg": 217,
	"./img/hardPine/dentationsHigherMag.jpg": 4529,
	"./img/hardPine/fusiformRay.jpg": 4887,
	"./img/hardPine/pinoidPitsHigherMag.jpg": 1569,
	"./img/hardPine/pinoidPitsLowerMag.jpg": 9683,
	"./img/hero.png": 928,
	"./logo-dark.svg": 1220,
	"./logo-light.svg": 9372,
	"./placeholder.png": 8145
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;